import { Button } from '@forgeglobal/design-framework';
import Form, {
  Field,
  FieldRenderProps,
  FormRenderProps,
} from '@tcs/common/components/atoms/Form';
import TextField from '@tcs/common/components/atoms/TextField';
import { object, string } from 'yup';
import { useStyles } from './style';

const validationSchema = object({
  email: string()
    .email('Email address must be valid')
    .required('Please enter your email address.'),
  identityId: string()
    .matches(
      /^(?![a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$)/,
      'Account number starts with 3 letters followed by 6 numbers (and 1 additional letter if applicable). If you’re a rep, enter your rep ID.'
    )
    .required('Please enter your account number.'),
});

interface IdentificationFormProps {
  onCancel: () => void;
  onSubmit: (data: { identityId: ''; email: '' }) => void;
}

const IdentificationForm = ({
  onCancel,
  onSubmit,
}: IdentificationFormProps) => {
  const classes = useStyles();
  return (
    <Form
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      render={({ handleSubmit, submitting }: FormRenderProps) => (
        <form onSubmit={handleSubmit}>
          <div className={classes.fields}>
            <Field
              name="identityId"
              render={(props: FieldRenderProps<string>) => (
                <TextField
                  label="Account number (e.g. IRA123456) or representative ID"
                  data-test-id="account-number-field"
                  autoComplete="username"
                  className={classes.field}
                  {...props}
                />
              )}
            />

            <Field
              name="email"
              render={(props: FieldRenderProps<string>) => (
                <TextField
                  label="Email address"
                  data-test-id="email-address-field"
                  {...props}
                />
              )}
            />
          </div>
          <div className={classes.buttons}>
            <Button
              size="medium"
              color="secondary"
              onClick={onCancel}
              data-test-id="cancel-button">
              Cancel
            </Button>

            <Button
              size="medium"
              color="primary"
              type="submit"
              disabled={submitting}
              className={classes.primaryButton}
              data-test-id="next-button">
              Next
            </Button>
          </div>
        </form>
      )}
    />
  );
};

export default IdentificationForm;
